module.exports = __webpack_public_path__ + "img/carte-bleue.b7a62a6d.svg";